Revolution.Module.extend({
    NAME: "mde.medias", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/medias.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée


        //_.bindAll(this, "equalheight", "runEqualHeight", "getHeightsForOffsets");

        //events

        this.initVideos();
        $('body').on('click', '.js-play-pause-dl-video', this.toggleBannerPlayPause);

    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },

    initVideos: function () {
        $('.js-plyr-media').each(function (index, elem) {

            var player = null;
            var options = {
                controls: [
                    'play', // Play/pause playback
                    'progress', // The progress bar and scrubber for playback and buffering
                    'current-time', // The current time of playback
                    'duration', // The full duration of the media
                    'mute', // Toggle mute
                    'volume', // Volume control
                ]
            };

            if ($(elem).find('video').length) {
                options.controls.push('play-large'); // The large play button in the center
                options.controls.push('fullscreen'); // Toggle fullscreen
                player = new Plyr($(elem).find('video'), options);
                if($(elem).data('poster')) {
                    player.poster = $(elem).data('poster');
                }
            }

            if ($(elem).find('audio').length) {
                options.controls.push('download'); // Show a download button with a link to either the current source or a custom URL you specify in your options
                player = new Plyr($(elem).find('audio'), options);
            }
        });
    },

    toggleBannerPlayPause: function () {

        var $span = $(this).find('.out');
        playText = $span.data('play-text');
        pauseText = $span.data('pause-text');
        if ($(this).hasClass('play')) {

            $(this).removeClass('play');
            $(this).addClass('pause');
            //
            if ($(this).closest('.bk-banner').find('video').length) {
                $(this).closest('.bk-banner').find('video').get(0).pause();
            }
            $span.html(playText);
        } else {
            $(this).removeClass('pause');
            $(this).addClass('play');
            if ($(this).closest('.bk-banner').find('video').length) {
                $(this).closest('.bk-banner').find('video').get(0).play();
            }
            $span.html(pauseText);
        }
    }

});
